export var ignoreErrors = ['Network Error', 'Request failed'];
//# sourceMappingURL=ignoreErrors.js.map